import { render, staticRenderFns } from "./SdsGhsLabel.vue?vue&type=template&id=45e91037&"
import script from "./SdsGhsLabel.vue?vue&type=script&lang=js&"
export * from "./SdsGhsLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports